import { uniqueId } from 'lodash';
import { NotificationTypes } from './constants';

const PREFIX = 'NOTIFICATIONS/';
export const ADD = `${PREFIX}ADD`;
export const REMOVE = `${PREFIX}REMOVE`;


export function add({ type, message }) {
  return {
    type: ADD,
    payload: {
      id: Number(uniqueId()),
      type,
      message,
    },
  };
}

export function remove({ id }) {
  return {
    type: REMOVE,
    payload: {
      id,
    },
  };
}

export function addSuccess({ message }) {
  return add({ type: NotificationTypes.SUCCESS, message });
}

export function addError({ message }) {
  return add({ type: NotificationTypes.ERROR, message });
}
